<div style="margin: 4em 4em 4em 4em; border: 2px solid transparent">
  <lib-order-details
    [labels]="'lib.orderDetails' | translate"
    [steps]="steps"
    [orderRef]="orderRef"
    [bank]="bank"
    [orderDate]="orderDate"
    [orderStatus]="orderStatus"
    [orderState]="order?.state ?? ''"
    [itemsNbr]="itemsNbr"
    [orderInfo]="orderInfo"
    [simulationInfo]="simulationInfo"
    [totalOrder]="totalOrder"
    [deliveryAddress]="deliveryAddress"
    [deliveryOption]="deliveryOption"
    [paymentOption]="paymentOption"
    [paymentMethod]="paymentMethod"
    [transferReceipt]="transferReceipt"
    [transferReceiptLoading]="transferReceiptLoading"
    [language]="language$ | async"
    (transferReceiptSubmitted)="sendTransferReceipt($event)"
    (filesUploaded)="onFilesClick()"
    (seeFolderClick)="onFilesClick()"
    (downloadOrderBillClicked)="makePdf()"
  >
  </lib-order-details>
</div>

<!-- pop up order created successfully 
<lib-order-createdpopup
  [labels]="'lib.orderCreatedPopup' | translate"
  *ngIf="(orderCreatedSuccessfully$ | async)"
  (importFolderBtn)="importFolder()"
  [theme]="bank">
</lib-order-createdpopup>

-->
